export default "__VITE_ASSET__CL_fzvN9__"